import { fade } from '@material-ui/core/styles/colorManipulator';

const primaryMain = '#7546a0';
const primaryLight = fade(primaryMain, 0.5);
const primaryUltraLight = fade(primaryMain, 0.1)
const secondaryMain = '#F57F29';
const white = '#FFFFFF';

export const palette = {
    primary: {
        main: primaryMain,
        dark: '#461b71',
        light: primaryLight,
        ultraLight: primaryUltraLight,
        boxShadow: fade(primaryMain, 0.25)
    },
    secondary: {
        main: secondaryMain
    },
    divider: '#BDBDBD',
    text: {
        primary: '#212121',
        secondary: '#757575',
        subTitle: fade(white, 0.6),
        menuItem: fade(white, 0.87),
        white
    },
    error: {
        main: '#FA4444'
    },
    background: {
        body: '#FAFAFA',
        black: '#000000',
        light: '#F2F2F2',
        main: '#EBEBEB',
        white
    }
};

export const tableColors = {
    tableRowBackground: palette.background.body,
    tableRowHover: primaryUltraLight,
    tableRowSelected: primaryUltraLight,
    defaultBackground: white
};

export const listColors = {
    listBackground: '#f7f7f7'
};

export const panelColors = {
    light: '#CCCCCC'
};
